import { TILE_TYPE } from '@shared/constants';

const filterProcuredOffers = (properties) =>
  properties.filter((p) => p.type === TILE_TYPE.PROCURED_OFFER);

export default filterProcuredOffers;
